import { AppActions, SET_CALC_TAB } from '../actions/actionTypes'
import { IAppData } from '../store/createStore'

const appReducer = (state: IAppData, action: AppActions): IAppData => {
  switch (action.type) {
    case SET_CALC_TAB:
      return { ...state, calcType: action.calcType }
    default:
      return { ...state }
  }
}

export default appReducer
